import auth from './auth';
import adverts from './adverts';
import chat from './chat';
import locale from './locale';
import media from './media';
import notifications from './notifications';
import preferences from './preferences';
import search from './search';
import savedSearch from './saved-search';
import subscriptions from './subscriptions';
import errors from './errors';
import user from './user';

export default {
	auth,
	adverts,
	chat,
	locale,
	media,
	notifications,
	preferences,
	search,
	"saved-search": savedSearch,
	subscriptions,
	errors,
	user
}